<div
  class="
  border-y-2 border-lighterText py-4
  lg:p-2 lg:border-2 lg:border-transparent lg:hover:border-black lg:transition-colors lg:duration-300"
>
  <div class="lg:text-lg font-semibold text-black">Kommunikation</div>

  <div class="flex flex-col">
    <div class="flex gap-4">
      <div class="text-lightText text-xs lg:text-sm flex flex-col">
        <span>
          Ich willige ein, von {{ brand.brandName().toUpperCase() }} über die aufgeführten Kanäle Mitteilungen zu meinen Interessen und Präferenzen zu erhalten.

          @if (!textExpanded) {
            <button
              class="text-lexusBlue hover:underline inline align-text-bottom"
              (click)="toggleExpand()"
            >
              [Weiterlesen]
            </button>
          }
        </span>

        @if (textExpanded) {
          <div [innerHTML]="descriptionText"></div>
          <button
            class="text-lexusBlue hover:underline self-start w-fit"
            (click)="toggleExpand()"
          >
            [Weniger anzeigen]
          </button>
        }
      </div>

      <div class="flex items-center lg:items-start gap-2">
        <app-checkbox-icon
          [imageClass]="getCommunicationIcon('unchecked')"
          (click)="setValueForAllContacts(ConsentStatus.WITHDRAWN)"
          class="cursor-pointer"
        />
        <app-checkbox-icon
          [imageClass]="getCommunicationIcon('checked')"
          (click)="setValueForAllContacts(ConsentStatus.CONFIRMED)"
          class="cursor-pointer"
        />
      </div>
    </div>

    <div class="w-full mt-4 ml-4 lg:ml-16">
      <app-contact-events
        [customerConsentRequest]="customerConsentRequest"
        [customerConsentResponse]="customerConsentResponse"
        [brand]="brand"
        (didChange)="handleContactEventChanged()"
      />
    </div>

    <div class="w-full mt-8 ml-4 lg:ml-16">
      <app-contact-channels
        [customerConsentRequest]="customerConsentRequest"
        [customerConsentResponse]="customerConsentResponse"
        [brand]="brand"
        (didChange)="handleContactChannelChanged()"
      />
    </div>
  </div>
</div>
